import { IWeekly } from '@/types/BusinessHours';

export const EMPTY: IWeekly = {
	SUNDAY: [],
	MONDAY: [],
	TUESDAY: [],
	WEDNESDAY: [],
	THURSDAY: [],
	FRIDAY: [],
	SATURDAY: [],
};

export const DEFAULT_WEEKLY: IWeekly = {
	SUNDAY: [],
	MONDAY: [{ start: '09:00', end: '17:00' }],
	TUESDAY: [{ start: '09:00', end: '17:00' }],
	WEDNESDAY: [{ start: '09:00', end: '17:00' }],
	THURSDAY: [{ start: '09:00', end: '17:00' }],
	FRIDAY: [{ start: '09:00', end: '17:00' }],
	SATURDAY: [],
};

export const MORNING: IWeekly = {
	SUNDAY: [],
	MONDAY: [{ start: '09:00', end: '14:00' }],
	TUESDAY: [{ start: '09:00', end: '14:00' }],
	WEDNESDAY: [{ start: '09:00', end: '14:00' }],
	THURSDAY: [{ start: '09:00', end: '14:00' }],
	FRIDAY: [{ start: '09:00', end: '14:00' }],
	SATURDAY: [],
};

export const AFTERNOON: IWeekly = {
	SUNDAY: [],
	MONDAY: [{ start: '14:00', end: '21:00' }],
	TUESDAY: [{ start: '14:00', end: '21:00' }],
	WEDNESDAY: [{ start: '14:00', end: '21:00' }],
	THURSDAY: [{ start: '14:00', end: '21:00' }],
	FRIDAY: [{ start: '14:00', end: '21:00' }],
	SATURDAY: [],
};

export const ALL_DAY: IWeekly = {
	SUNDAY: [],
	MONDAY: [
		{ start: '09:00', end: '14:00' },
		{ start: '16:00', end: '20:00' },
	],
	TUESDAY: [
		{ start: '09:00', end: '14:00' },
		{ start: '16:00', end: '20:00' },
	],
	WEDNESDAY: [
		{ start: '09:00', end: '14:00' },
		{ start: '16:00', end: '20:00' },
	],
	THURSDAY: [
		{ start: '09:00', end: '14:00' },
		{ start: '16:00', end: '20:00' },
	],
	FRIDAY: [
		{ start: '09:00', end: '14:00' },
		{ start: '16:00', end: '20:00' },
	],
	SATURDAY: [],
};
